'use strict'; 
import $ from "jquery";
import loadingIndicator from '../../templates/_helpers/loading-indicator.hbs';
import btnLoadingIndicator from '../../templates/_helpers/btn-loading-indicator.hbs';

$.fn.showLoadingIndicator = function(noMaxHeight, forceParentRelative) {
    if(typeof(noMaxHeight) == 'undefined') {
        noMaxHeight = false;
    }
    if(typeof(forceParentRelative) == 'undefined') {
        forceParentRelative = false;
    }
    this.removeLoadingIndicator();
    this.prepend(loadingIndicator());
    if(noMaxHeight == true) {
        this.find('.loading-indicator').addClass('no-max-height');
    }
    if(forceParentRelative == true) {
        this.addClass('loading-indicator-relative');
        this.find('.loading-indicator').addClass('parent-made-relative');
    }
    return this; // This is needed so other functions can keep chaining off of this
};

$.fn.removeLoadingIndicator = function() {
    let $li = this.find('.loading-indicator');
    if($li.hasClass('parent-made-relative')) {
        this.removeClass('loading-indicator-relative');
    }
    $li.remove();
    return this;
}

$.fn.replaceLoadingIndicator = function(newContent) {
    if(this.find('.loading-indicator').length == 0)
    {
        this.showLoadingIndicator();
    }
    this.find('.loading-indicator').html(newContent);
    return this;
}

$.fn.showPaginationIndicator = function() {
    $(this).removePaginationIndicator();
    let $i = $('<div class="pagination-indicator"></div>');
    $i.showLoadingIndicator();
    $(this).append($i);
}

$.fn.removePaginationIndicator = function() {
    $(this).find(".pagination-indicator").remove();
}

$.fn.addButtonLoading = function(){ 
    this.addClass('loading-hbs disabled');
    this.attr('disabled');
    this.append(btnLoadingIndicator());
    return this;
}
$.fn.removeButtonLoading = function(){ 
    this.removeClass('loading-hbs disabled');
    this.find('.loading-indicator').remove();
    this.removeAttr('disabled');
    return this;
}